import { render, staticRenderFns } from "./addClass.pug?vue&type=template&id=350ad618&scoped=true&lang=pug&"
import script from "./addClass.ts?vue&type=script&lang=ts&"
export * from "./addClass.ts?vue&type=script&lang=ts&"
import style0 from "./addClass.styl?vue&type=style&index=0&id=350ad618&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ad618",
  null
  
)

export default component.exports